import './document-view.css';

import type { TabsProps } from 'antd';
import { Badge, DatePicker, Form, Input, Tabs } from 'antd';
import dayjs from 'dayjs';
import { DocumentsApiService } from 'features/document-report/api/documents-api.service';
import { AttentionDocumentView } from 'features/document-report/components/attention-documents/attention-documents-view';
import { CommentsItemView } from 'features/document-report/components/comments/add-comments';
import { DocumentsDetails } from 'features/document-report/components/details/documents-details';
import { AddDocumentsModal } from 'features/document-report/components/modal/document-modal/add-document';
import { DocumentCategoryView } from 'features/document-report/components/new-documents/document-category';
import { RejectedDocumentView } from 'features/document-report/components/rejected-documents/rejected-document-view';
import { RequestedDocumentView } from 'features/document-report/components/requested-documents/requested-view';
import { useDocumentsCount } from 'features/document-report/use-cases/document-count';
import { useAssignDocuments } from 'features/document-report/use-cases/get-assign-documents';
import { useGetMarkFinished } from 'features/document-report/use-cases/get-markFinished';
import { usePendingDocuments } from 'features/document-report/use-cases/get-pending-document';
import { useUserContext } from 'features/users';
import { Fragment, useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { disabledDate } from 'routes/utils';
export const DocumentView = () => {
  const { user, menuItem, companyUser } = useUserContext();
  const navigate = useNavigate();
  const [documentUploadModal, setDocumentUploadModal] = useState(false);
  const [activeTab, setActiveTab] = useState<string>(
    localStorage.getItem('activeTab') || '1',
  );
  const location = useLocation();
  const searchParams: any = new URLSearchParams(location.search);
  const activeTabValue = searchParams.get('activeTab');
  // const [year, setYear] = useState(dayjs().year().toString());
  // const [month, setMonth] = useState((dayjs().month() + 1).toString());
  // const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedDate, setSelectedDate] = useState<dayjs.Dayjs | null>(() => {
    const savedDate = localStorage.getItem('selectedDate');

    return savedDate ? dayjs(savedDate) : null; // Use null if no date is saved
  });
  const [year, setYear] = useState(() =>
    selectedDate
      ? selectedDate.year().toString()
      : new Date().getFullYear().toString(),
  );
  const [month, setMonth] = useState(() =>
    selectedDate
      ? (selectedDate.month() + 1).toString()
      : (new Date().getMonth() + 1).toString(),
  );
  const [searchName, setSearchName] = useState('');
  const [addCommentsModal, setAddCommentsModal] = useState(false);
  const { mutate: getMarkfinished, data: finishedValue } = useGetMarkFinished();
  const [commentsInfo, setCommentsInfo] = useState('');
  const { mutate: getCount, data: apiCountValue } = useDocumentsCount();
  const { refetch } = useAssignDocuments(user?.CompanyId);
  const [requestdocuments, setRequestDocuments] = useState('');
  const [rejectdocument, setRejectDocument] = useState('');
  const { data: pending, refetch: pendingrefetch } = usePendingDocuments(
    `${user?.CompanyId}&DocumentStatusId=1`,
  );
  const [countValue, setCountValue] = useState<Record<string, number>>({
    requestedDocument: 0,
    rejectedDocument: 0,
    attentionDocument: 0,
  });
  const initilaMarkFinished = () => {
    const FinishedData: any = {
      companyId: user?.CompanyId,
      Year: +year,
      Month: +month,
      ClientId: user?.Id,
      // periodId: selectedValue,
    };
    getMarkfinished(FinishedData);
  };
  const getDocumentsCount = () => {
    const formdata = {
      companyId: user?.CompanyId,
      Year: +year,
      Month: +month,
      ClientId: user?.Id,
    };
    getCount(formdata);
  };
  const handleClick = (key: string) => {
    if (key == 'Requested') {
      const requestdocuments1: any = {
        CompanyId: user?.CompanyId,
        PageIndex: 1,
        RecordPerPage: 10,
        DocumentStatusId: 0, // for requested
        Year: year,
        Month: month,
        ClientId: user?.Id,
      };
      (async () => {
        try {
          const apires = await DocumentsApiService().getRequestDocument(
            requestdocuments1,
          );
          setRequestDocuments(apires);
        } catch (error) {
          console.error('Error fetching documents:', error);
        }
      })();
    }
    if (key == 'RejectedDocuments') {
      const rejectedDocuments: any = {
        CompanyId: user?.CompanyId,
        PageIndex: 1,
        RecordPerPage: 20,
        DocumentStatusId: 3, // for requested
        Year: year,
        Month: month,
        ClientId: user?.Id,
        Name: searchName,
      };
      (async () => {
        try {
          const apires = await DocumentsApiService().getRejectedDocument(
            rejectedDocuments,
          );
          setRejectDocument(apires);
        } catch (error) {
          console.error('Error fetching documents:', error);
        }
      })();
    }
  };
  const items: TabsProps['items'] = [
    {
      key: '1',
      label: 'Documents',
      children: (
        <DocumentCategoryView
          setAddCommentsModal={setAddCommentsModal}
          setCommentsInfo={setCommentsInfo}
          setDocumentUploadModal={setDocumentUploadModal}
          // selectedValue={selectedValue}
          month={month}
          year={year}
          searchName={searchName}
          finishedValue={finishedValue}
          initilaMarkFinished={initilaMarkFinished}
          // selectFilterValue={selectFilterValue}
        />
      ),
    },
    {
      key: '2',
      label: (
        <div role='button' onClick={() => handleClick('Requested')}>
          <Badge count={countValue.requestedDocument}>
            Requested Documents
          </Badge>
        </div>
      ),
      children: (
        <RequestedDocumentView
          pendingDocument={pending}
          pendingrefetch={pendingrefetch}
          setAddCommentsModal={setAddCommentsModal}
          setCommentsInfo={setCommentsInfo}
          searchName={searchName}
          getDocumentsCount={getDocumentsCount}
          month={month}
          year={year}
          finishedValue={finishedValue}
          initilaMarkFinished={initilaMarkFinished}
          requestdocuments={requestdocuments}
          handleClick={handleClick}
        />
      ),
    },
    {
      key: '3',
      label: (
        <div role='button' onClick={() => handleClick('RejectedDocuments')}>
          <Badge count={countValue.rejectedDocument}>Rejected Documents</Badge>
        </div>
      ),
      children: (
        <RejectedDocumentView
          setAddCommentsModal={setAddCommentsModal}
          setCommentsInfo={setCommentsInfo}
          // selectedValue={selectedValue}
          year={year}
          month={month}
          searchName={searchName}
          getDocumentsCount={getDocumentsCount}
          finishedValue={finishedValue}
          initilaMarkFinished={initilaMarkFinished}
          handleClick={handleClick}
          rejectdocument={rejectdocument}
        />
      ),
    },
    {
      key: '4',
      label: (
        <Badge count={countValue.attentionDocument}>Attention Required</Badge>
      ),
      children: (
        <AttentionDocumentView
          setAddCommentsModal={setAddCommentsModal}
          setCommentsInfo={setCommentsInfo}
          year={year}
          month={month}
          getDocumentsCount={getDocumentsCount}
          searchName={searchName}
          // selectedValue={selectedValue}
        />
      ),
    },
  ];
  const handleTabChange = (key: string) => {
    setActiveTab(key);
    localStorage.setItem('activeTab', key); // Save active tab to local storage
  };
  useEffect(() => {
    if (activeTabValue) {
      setActiveTab(activeTabValue);
    }
  }, []);
  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchName(e.target.value);
  };
  const handleDateChange = (date: any) => {
    if (date) {
      // Update to the selected date
      setSelectedDate(date);
      setYear(date.year().toString());
      setMonth((date.month() + 1).toString());
      localStorage.setItem('selectedDate', date.toISOString()); // Persist date
    } else {
      // Reset to the current date when cleared
      const currentDate = dayjs();
      setSelectedDate(currentDate);
      setYear(currentDate.year().toString());
      setMonth((currentDate.month() + 1).toString());
      localStorage.removeItem('selectedDate'); // Remove stored date if cleared
    }
  };
  useEffect(() => {
    if (activeTab === '2') {
      refetch();
      pendingrefetch();
    }
  }, [activeTab, refetch, pendingrefetch]);
  useEffect(() => {
    getDocumentsCount();
    const interval = setInterval(() => {
      getDocumentsCount();
    }, 10000); // 10000ms = 10 seconds

    return () => clearInterval(interval);
  }, [year, month]);
  useEffect(() => {
    initilaMarkFinished();
    handleClick('RejectedDocuments');
  }, [year, month, searchName]);
  useEffect(() => {
    if (menuItem?.rc[0]?.Url === 'dashboard') {
      navigate('/dashboard');
    }
  }, [menuItem?.rc[0]?.Url, navigate]);
  useEffect(() => {
    if (!companyUser?.rc || companyUser.rc.length === 0) {
      navigate('/no-company'); // Redirect to "not found" route
    }
  }, [companyUser?.rc, navigate]);
  useEffect(() => {
    if (apiCountValue) {
      const newCount = {
        requestedDocument: apiCountValue?.rc[0]?.requestedDocument || 0,
        rejectedDocument: apiCountValue?.rc[0]?.rejectedDocument || 0,
        attentionDocument: apiCountValue?.rc[0]?.attentionDocument || 0,
      };
      if (newCount.requestedDocument > countValue.requestedDocument) {
        handleClick('Requested');
      } else if (newCount.rejectedDocument > countValue.rejectedDocument) {
        handleClick('RejectedDocuments');
      }
      // Only update state if newCount is different from countValue
      if (
        newCount.requestedDocument !== countValue.requestedDocument ||
        newCount.rejectedDocument !== countValue.rejectedDocument ||
        newCount.attentionDocument !== countValue.attentionDocument
      ) {
        setCountValue(newCount);
      }
    }
  }, [apiCountValue, countValue]);

  return (
    <Fragment>
      <DocumentsDetails user={user} />

      <div className='bg-white p-4 rounded-lg'>
        <div className='flex-col gap-2 justify-between sm:flex md:flex-row flex'>
          <h3 className='text-xl text-[#313030] font-semibold'>Documents</h3>

          <div className='flex gap-2 justify-between'>
            <Form.Item className='mb-0'>
              <Input
                placeholder='Search by Name'
                value={searchName} // Controlled input value
                onChange={handleSearchChange}
              />
            </Form.Item>
            <Form.Item className='mb-0'>
              <DatePicker
                className='form-control'
                picker='month'
                value={selectedDate || dayjs()}
                defaultValue={dayjs()} // Default to current month/year
                onChange={handleDateChange as any}
                disabledDate={disabledDate}
                allowClear={false}
                format={!selectedDate ? 'MMMM YYYY' : 'MMMM YYYY'}
              />
            </Form.Item>
          </div>
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={handleTabChange}
          items={items}
          className='bg-white px-0 py-4 custom-tabs '
        />
        {documentUploadModal && (
          <AddDocumentsModal
            onClose={() => setDocumentUploadModal(false)}
            pendingrefetch={pendingrefetch}
            month={month}
            year={year}
          />
        )}
        {addCommentsModal && (
          <CommentsItemView
            onClose={() => setAddCommentsModal(false)}
            commentsInfo={commentsInfo}
            getDocumentsCount={getDocumentsCount}
          />
        )}
      </div>
    </Fragment>
  );
};
